import { DialogProps } from "@mui/material";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useFetcher, useLoaderData } from "react-router-dom";
import { packObjForSubmit, unpackObjForSubmit } from "../../utils";
import { doFetch } from "../../utils/doFetch";
import { doFetchPut } from "../../utils/doFetchPut";
import DynamicTable from "./CurrentDispatchLines";
import { ICurrentDispatchLinesData } from "./CurrentDispatchLinesData";

export const currentDispatchLinesRouteLoader = async ({ request }: { request: any }) => {
  return doFetch(`my-dispatch-lines`, { signal: request.signal }, true, true)
}

export const currentDispatchLinesRouteAction = async ({ request }: { request: any, params: any }) => {
  let formData = await request.formData();
  let obj = JSON.parse(unpackObjForSubmit(formData));
  return doFetchPut(`my-dispatch-lines/${obj.acceptFlag}`, { signal: request.signal });
}

export const CurrentDispatchLinesRoute = () => {
  const auth = useAuth();
  const fetcher = useFetcher();
  const loaderData = useLoaderData() as ICurrentDispatchLinesData;
  const data = loaderData;
  const currentRegistrationNumber = auth.user?.profile.sub;
  const [selectedOrderDetailId, setSelectedOrderDetailId] = useState<string>('');

  const handleSubmit = async (acceptFlag: 0 | 1) => {
    fetcher.submit(
      packObjForSubmit({ acceptFlag }),
      {
        method: "put",
        action: `/current-lines-dispatch`,
      }
    );

    setSelectedOrderDetailId('');
  }

  const handleShowSlip = (id: string) => {
    setSelectedOrderDetailId(id);
  }

  const handleBackdropClick: DialogProps["onClose"] = (_, reason) => {
    if (reason && reason === "backdropClick")
      handleShowSlip('');
  }

  return (
    <DynamicTable
      handleSubmit={handleSubmit}
      data={data}
      currentRegistrationNumber={currentRegistrationNumber}
      selectedOrderDetailId={selectedOrderDetailId}
      handleShowSlip={handleShowSlip}
      handleBackdropClick={handleBackdropClick}
    />
  )
}
